<h1>{{ 'gardenOrRestaurant.reservation' | translate }}</h1>
<div class="main-content">
  <div class="content">
    <img src="assets/icon_rest.png" width="160">
    <div class="text">{{ 'gardenOrRestaurant.local' | translate }}</div>
    <button (click)="reserved('local')">{{ 'gardenOrRestaurant.book' | translate }}</button>
  </div>
  <div class="content">
    <img src="assets/icon_ogrod.png" width="160">
    <div class="text">{{ 'gardenOrRestaurant.garden' | translate }}</div>
    <button (click)="reserved('garden')">{{ 'gardenOrRestaurant.book' | translate }}</button>
  </div>
</div>
